import { colors, spacing } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import {
  Pressable,
  StyleProp,
  StyleSheet,
  Text,
  ViewStyle,
} from 'react-native';
import { RobotTutorial } from '../types';

type Props = {
  tutorial: RobotTutorial;
  disabled?: boolean;
  onPress?: () => any;
  style?: StyleProp<ViewStyle>;
};

export const RobotTutorialButton = (props: Props) => {
  const { tutorial, disabled = false } = props;

  const contentColor = disabled ? colors.grey.dim : colors.secondary[700];

  return (
    <Pressable
      style={({ pressed }) => [
        styles.container,
        disabled ? styles.disabledBackground : styles.background,
        {
          opacity: pressed ? 0.5 : 1,
          elevation: pressed || disabled ? 0 : 2,
        },
        props.style,
      ]}
      disabled={disabled}
      onPress={() => props.onPress?.()}
    >
      <FontAwesomeIcon icon={'play'} color={contentColor} size={30} />
      <Text style={[styles.textStyle, { color: contentColor }]}>
        {tutorial.displayName}
      </Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    margin: spacing[2],
    paddingHorizontal: spacing[3],
    paddingVertical: spacing[5],
    alignItems: 'center',
    gap: spacing[2],
    flexDirection: 'row',
  },
  background: {
    backgroundColor: colors.blue.background,
    borderRadius: 10,
  },
  disabledBackground: {
    backgroundColor: colors.grey[300],
    borderRadius: 10,
  },
  textStyle: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  iconContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  text: {
    fontWeight: 'bold',
    textAlign: 'center',
    textAlignVertical: 'center',
    height: '30%',
  },
});
